"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZipCode = exports.Email = exports.Currency = exports.Mileage = exports.PhoneNumber = exports.Name = void 0;
var Name = /^[A-Za-z].{0,18}[A-Za-z]$/;
exports.Name = Name;
var PhoneNumber = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
exports.PhoneNumber = PhoneNumber;
var Mileage = /^[\d]*([\d]+,?[\d]+)*([\d][\d]*)?$/;
exports.Mileage = Mileage;
var Currency = /^\$*[\d]*([\d]+,?[\d]+)*([\d]+\.?[\d]*)?$/;
exports.Currency = Currency;
var Email = /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\.)+([A-Za-z]{2,4})$/;
exports.Email = Email;
var ZipCode = /^(\d{5}-\d{4})|(\d{5})$/;
exports.ZipCode = ZipCode;